/**
 * Pitch acceptance rate
 * @author Ryan Gladstone
 * Webpack migration by Umer Hassan
 */

const vizPitchAcceptanceController = ($scope, $translate, statsService) => {
  const endTime = Math.floor(Date.now() / 1000);
  const startTime = endTime - (3600 * 24);

  statsService.getPitchAcceptanceRate(
    startTime, endTime,
    $scope.filterSet.getFilterValue('sections'),
    $scope.filterSet.getFilterValue('platforms')
  ).then((data) => {
    if (Number.isNaN(Number(data))) {
      $scope.percent = $translate.instant('NO_DATA');
    } else {
      $scope.percent = `${data}%`;
    }
    $scope.label = $translate.instant('PITCHES_ACCEPTED');
  }, () => {
    $scope.percent = $translate.instant('ERROR');
  });
};

const directive = () => ({
  restrict: 'E',
  scope: {
    filterSet: '='
  },
  template: '<h4>{{ percent }}</h4>{{ label }}',
  controller: ['$scope',
    '$translate',
    'statsService',
    vizPitchAcceptanceController]
});

export default function (ngModule) {
  ngModule.directive('vizPitchAcceptance', directive);
}
